import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import Cross from "@safecv/assets/Images/cross.png";
import { connect } from "react-redux";
import _ from "lodash";
import { PROFILE_PREFERENCE } from "@safecv/shared/appConstant";

import { postPreference } from "@safecv/actions/postActions";

const customModalStylesUpload = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    padding: "0rem",
    width: "360px",
    transform: "translate(-50%, -50%)",
  },
};

function ManagePreferencesModal({
  closeModalForPreferences,
  modalState,
  postPreference,
  preference,
  canBeClosed,
}) {
  const [annotatedSelected, setAnnotatedSelected] = useState(false);
  const [complianceSelected, setComplianceSelected] = useState(false);

  useEffect(() => {
    if (_.toString(_.values(preference)) === "annotation"){
      setAnnotatedSelected(true);
      setComplianceSelected(false);
      }
    else if (_.toString(_.values(preference)) === "compliance,violation"){
      setAnnotatedSelected(false);
      setComplianceSelected(true);
      }
    localStorage.setItem(PROFILE_PREFERENCE, JSON.stringify(preference));
  }, [preference]);

  return (
    <div>
      <Modal
        isOpen={modalState}
        style={customModalStylesUpload}
        ariaHideApp={false}
        contentLabel="Manage preference modal"
      >
        <div className="row" id="bgcolor">
          <div className="col-8" id="custom-padding">
            <h1 id="fsizeupload">Manage Preferences</h1>
          </div>
          <div
            className="col-4"
            id="custom-styling"
            style={{ display: canBeClosed ? "block" : "none" }}
          >
            <img
              src={Cross}
              onClick={closeModalForPreferences}
              alt="quit"
              className="crossStyle"
            />
          </div>
        </div>
        <div style={{ padding: "2rem" }}>
          <h4 className="preference-coloring">
            Please identify the outputs that you send back to the applicant
          </h4>
          <div className="preferences-styling">
            <input
              className="radio-button-align"
              type="radio"
              value="Comments letter only"
              name="prefrences"
              checked={complianceSelected}
              onChange={() => {
                postPreference({ output: "compliance,violation" });
                setComplianceSelected(true);
                closeModalForPreferences();
              }}
            />
            Comments letter only
          </div>
          <div className="preferences-styling">
            <input
              className="radio-button-align"
              type="radio"
              value=" Both Annotated plan and Comments letter"
              name="prefrences"
              checked={annotatedSelected}
              handle
              onChange={() => {
                postPreference({ output: "annotation" });
                setAnnotatedSelected(true);
                closeModalForPreferences();
              }}
            />
            Both Annotated plan and Comments letter
          </div>
        </div>
      </Modal>
    </div>
  );
}
const mapStatetoProps = (state) => ({
  preference: state.criteria.preference,
});

const mapDispatchtoProps = (dispatch) => {
  return {
    postPreference: (data) => {
      dispatch(postPreference(data));
    },
  };
};

export default connect(
  mapStatetoProps,
  mapDispatchtoProps
)(ManagePreferencesModal);
